import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FileServices from 'services/FileServices';

const OrgImage = ({
  orgId,
  logo,
  alt = 'Organization Logo',
  className = '',
  width = 64,
  height = 64,
  fallbackSrc = '/assets/images/no-header-img.jpg',
  onClick,
  showFullscreen = false,
  cacheBuster = null,
}) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  // Fullscreen preview state removed

  useEffect(() => {
    let objectUrl = null;
    const loadImage = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const url = await FileServices.getOrgtImage(logo, orgId,cacheBuster);
        setImageUrl(url);
        if (url?.startsWith('blob:')) {
          objectUrl = url;
        }
        setIsLoading(false);
      } catch (err) {
        console.error('Image loading error:', err);
        setError('Failed to load image');
        setIsLoading(false);
      }
    };
    if (orgId && logo) {
      loadImage();
    } else {
      setImageUrl(fallbackSrc);
      setIsLoading(false);
    }
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [orgId, logo, fallbackSrc,cacheBuster]);

  const handleImageClick = () => {
    // Fullscreen preview disabled/commented out
    // if (showFullscreen) {
    //   setIsFullscreen((prev) => !prev);
    // }
    if (onClick) {
      onClick();
    }
  };

  const renderImage = (fullscreen = false) => {
    if (isLoading) {
      return (
        <div className="flex items-center justify-center" style={{ width, height }}>
          <span className="text-gray-500 text-sm">Loading...</span>
        </div>
      );
    }
    const src = error || !imageUrl ? fallbackSrc : imageUrl;
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        width={fullscreen ? '100%' : width}
        height={fullscreen ? 'auto' : height}
        style={{ objectFit: 'cover', cursor: showFullscreen ? 'pointer' : 'default', borderRadius: '50%' }}
        onClick={handleImageClick}
      />
    );
  };

  return (
    <>
      {renderImage(false)}
      {/*
      {isFullscreen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setIsFullscreen(false)}
        >
          {renderImage(true)}
        </div>
      )}
      */}
    </>
  );
};

OrgImage.propTypes = {
  orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  logo: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  fallbackSrc: PropTypes.string,
  onClick: PropTypes.func,
  showFullscreen: PropTypes.bool,
};

export default OrgImage;
